<div class="header-bar">
  <div style="display: flex; flex-wrap: wrap">
    <div style="flex-grow: 1">
      <h1>Banner Management</h1>
    </div>
    <div style="flex-shrink: 1; padding-top: 10px" *ngIf="!editMode">
      <button
        *ngIf="isBannerAdministrator"
        type="button"
        class="button-blue"
        pButton
        icon="fa fa-plus"
        (click)="createBanner()"
        label="Create Banner"
      ></button>
    </div>
  </div>
</div>

<div class="">
  <div class="">
    <div *ngIf="editMode; else listMode">
      <app-banner-edit
        [editBanner]="editBannerDTO"
        (bannerEditFinished)="onBannerEditFinished($event)"
      ></app-banner-edit>
    </div>

    <ng-template #listMode>
      <div style="width: 100%">
        <p-tabView class="tab-padding" styleClass="engineius" [(activeIndex)]="selectedTab">
          <p-tabPanel header="Active & Scheduled">
            <ng-template pTemplate="content">
              <app-banner-management-list
                [banners]="banners.get(bannerType.Active)"
                [editMode]="editMode"
                (reloadBanners)="onReloadBanners()"
                (editSelectedBanner)="onEditBanner($event)"
                (createNewBanner)="createBanner()"
                [upcomingBanners]="banners.get(bannerType.Upcoming)"
              ></app-banner-management-list>
            </ng-template>
          </p-tabPanel>
          <p-tabPanel header="Archived & Draft">
            <ng-template pTemplate="content">
              <app-banner-management-list
                [banners]="banners.get(bannerType.Draft)"
                [editMode]="editMode"
                (reloadBanners)="onReloadBanners()"
                (editSelectedBanner)="onEditBanner($event)"
                (createNewBanner)="createBanner()"
              ></app-banner-management-list>
            </ng-template>
          </p-tabPanel>
        </p-tabView>
      </div>
    </ng-template>
  </div>
</div>

<p-confirmDialog #cd [style]="{ width: '425px' }">
  <p-footer>
    <button type="button" pButton label="No, Cancel" (click)="cd.reject()"></button>
    <button
      type="button"
      pButton
      class="ui-button ui-button-danger"
      label="Yes, Delete"
      (click)="cd.accept()"
    ></button>
  </p-footer>
</p-confirmDialog>
